import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'five-trends-shaping',
  template: require('./five-trends-shaping.component.html'),
  styles: [require('./../blog.component.scss'), require('./five-trends-shaping.component.scss')]
})
export class FiveTrendsShapingComponent extends BlogPage {
  title = '5 Trends Shaping the Global Maritime Industry - Linescape';
  description = 'As much as the global economy relies on international shipping to keep vital commodities moving safely and efficiently, the maritime industry relies on the world’s economies to keep driving the demand for shipping.';

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/five-trends-shaping/five-trends-shaping.component.ts